export default __webpack_public_path__ + "static/media/CL01.1.559c37a2.mp3";